module.exports = __webpack_public_path__ + "img/bg_function06_2_m.ab624363.png";